import * as React from "react";
const Check = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M4.9997,12.1379 L5.70680678,11.4307932 L9.7837,15.5067932 L18.2925932,6.99979322 L18.9997,7.7069 L10.4918068,16.2147932 L9.7847,16.9219 L4.9997,12.1379 Z" }));
Check.displayName = "Check";
var Check_default = Check;
export {
  Check_default as default
};
